/* eslint-disable @intercom/intercom/no-bare-strings */

import { centerable, stylable } from '../decorators';
import { BLOCK_CLASSES } from '@intercom/composer-ember/lib/blocks/constants';
import tinycolor from 'tinycolor2';
import { getBackgroundColor } from '@intercom/composer-ember/lib/config/specs/nodes/spec-util';
export let getButtonBackgroundColor = dom => {
  let anchorElement = dom.querySelector('a');
  let color = anchorElement?.style?.backgroundColor;
  if (color === 'transparent') {
    color = anchorElement?.style?.borderColor;
  }
  if (!color) {
    return '';
  }
  return getBackgroundColor(color);
};
let fontColorStyleForButton = hexColor => {
  let color = tinycolor(hexColor);
  if (!color.isValid()) {
    return '';
  }
  let luminence = tinycolor(hexColor).getLuminance();
  if (luminence > 0.179) {
    return 'color: #000000;';
  } else {
    return 'color: #ffffff;';
  }
};
let getButtonStyle = node => {
  if (node.attrs.buttonStyle === 'outline') {
    return `border-color: ${node.attrs?.backgroundColor}; ` + `background-color: transparent; border-style: solid;`;
  } else {
    return `border-color: transparent; background-color: ${node.attrs?.backgroundColor}; border-style: solid;`;
  }
};
function getButtonStyleAttribute(dom) {
  return dom.querySelector('a')?.style?.backgroundColor === 'transparent' ? 'outline' : 'solid';
}
export const buttonSpec = stylable(centerable({
  inline: false,
  attrs: {
    type: {
      default: 'button'
    },
    linkUrl: {
      default: ''
    },
    text: {
      default: ''
    },
    buttonStyle: {
      default: 'solid'
    }
  },
  group: 'block',
  parseDOM: [{
    tag: `div.${BLOCK_CLASSES.button}`,
    getAttrs(dom) {
      return {
        linkUrl: dom.getAttribute('data-link-url'),
        text: dom.textContent,
        backgroundColor: getButtonBackgroundColor(dom),
        buttonStyle: getButtonStyleAttribute(dom)
      };
    }
  }, {
    tag: `div.intercom-interblocks-button`,
    getAttrs(dom) {
      let anchorElement = dom.querySelector('a');
      return {
        linkUrl: anchorElement?.getAttribute('href'),
        text: dom.textContent,
        backgroundColor: getButtonBackgroundColor(dom),
        buttonStyle: getButtonStyleAttribute(dom)
      };
    }
  }],
  toDOM(node) {
    let {
      text,
      fontColor
    } = node.attrs;
    if (!text) {
      text = 'Enter button text';
    }
    let fontColorStyle = fontColor ? `color: ${fontColor};` : fontColorStyleForButton(node.attrs?.backgroundColor);
    let buttonStyle = getButtonStyle(node);
    return ['div', {
      class: `${BLOCK_CLASSES.blockContainer} ${BLOCK_CLASSES.button}`,
      'data-link-url': node.attrs.linkUrl
    }, ['a', {
      class: 'intercom-h2b-button',
      style: `${buttonStyle} ${fontColorStyle} `
    }, text]];
  }
}));